(function () {
  'use strict';

  var DAYS_FR = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MONTHS_FR = ['jan.', 'fév.', 'mar.', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sep.', 'oct.', 'nov.', 'déc.'];

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var dow = result.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return result;
  }

  function formatDate(date) {
    var d = date.getDate();
    var m = MONTHS_FR[date.getMonth()];
    return d + ' ' + m;
  }

  function initBlock(block) {
    var deliveryRow = block.querySelector('[data-wbdi-delivery]');
    var deliveryText = block.querySelector('[data-wbdi-delivery-text]');

    if (!deliveryRow || !deliveryText) return;

    var delayMin = parseInt(block.getAttribute('data-delay-min'), 10) || 2;
    var delayMax = parseInt(block.getAttribute('data-delay-max'), 10) || 4;
    var prefix = block.getAttribute('data-prefix') || 'Livraison entre le';

    var now = new Date();
    var dateMin = addBusinessDays(now, delayMin);
    var dateMax = addBusinessDays(now, delayMax);

    deliveryText.innerHTML = prefix + ' <strong>' + formatDate(dateMin) + '</strong> et le <strong>' + formatDate(dateMax) + '</strong>';
  }

  function init(container) {
    var blocks = container.querySelectorAll('[data-wbdi-block]');
    blocks.forEach(function (block) { initBlock(block); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

})();